import AOS from 'aos';
import 'aos/dist/aos.css';

// AOS
AOS.init({
  duration: 1000,
  once: true
});
